import type { CSSProperties } from "react";
import { FitText } from "../../components/FitText";
import { Mascot } from "../../components/Mascot";
import { MASCOT } from "../../lib/mascot";

/** Two lines at most: broken at the space nearest the middle, so both lines are about as long. */
function twoLines(text: string): string[] {
  const mid = text.length / 2;
  let at = -1;
  for (let i = text.indexOf(" "); i >= 0; i = text.indexOf(" ", i + 1)) {
    if (at < 0 || Math.abs(i - mid) < Math.abs(at - mid)) at = i;
  }
  if (at < 0 || text.length <= 16) return [text];
  return [text.slice(0, at), text.slice(at + 1)];
}

/**
 * The admin's message: a block of ink across the middle of the wall, the words as big as fit on
 * two lines. The size starts from the longer line's length and FitText takes up what is left.
 * The host announces it (decision 45): his name above the words, and him standing on the block.
 */
export function Notice({ text, inline }: { text: string; inline?: boolean }) {
  const lines = twoLines(text);
  const chars = Math.max(...lines.map((l) => l.length));
  const block = (
    <div className="proj-notice" role="status" style={{ "--chars": chars } as CSSProperties}>
      <p className="notice-from">{`By order of ${MASCOT.name}`}</p>
      <FitText className="notice-text wall-display" min={0.3}>
        {lines.join("\n")}
      </FitText>
      {inline ? null : <Mascot pose="calling" className="notice-host" />}
    </div>
  );
  // inline: a line of the pause screen, laid out by it, not across the middle of the wall
  return inline ? block : <div className="proj-notice-wrap">{block}</div>;
}
